import { ErrorState } from "@idw-types/state";

export enum ErrorActionTypes {
    SET_ERROR = "SET_ERROR"
}

type SetErrorAction = {
    type: ErrorActionTypes.SET_ERROR,
    payload: { error: ErrorState };
};

export const setError = (error: ErrorState) => ({
    type: ErrorActionTypes.SET_ERROR,
    payload: { error }
});

export type ErrorActions = SetErrorAction;